import { useModal } from '@ebay/nice-modal-react';
import { Bot, Edit } from 'lucide-react';
import useAgent from '@/hooks/useAgent';
import Loading from '../Loading';
import Section from '../Section';
import { Button } from '../ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';

const Agent = () => {
  const drawer = useModal('agent-drawer');
  const agent = useAgent();

  if (agent.isLoading || !agent.data) {
    return <Loading />;
  }

  return (
    <>
      <div className="flex items-center justify-between gap-2 mb-8">
        <div className="flex items-center gap-2 mb-4 ">
          <Bot />
          <div className="text-lg font-bold">Call Agent</div>
        </div>
        <Button className="ml-auto" onClick={() => drawer.show({ agent: agent?.data })}>
          <Edit />
          Edit Agent
        </Button>
      </div>

      <Section>
        <Tabs defaultValue="overview" className="w-full">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="prompt">Prompt</TabsTrigger>
            <TabsTrigger value="summaryPrompt">Summary Prompt</TabsTrigger>
            <TabsTrigger value="analysisPrompt">Analysis Prompt</TabsTrigger>
          </TabsList>

          <TabsContent value="overview">
            <div className="grid gap-4 mt-4">
              <div>
                <p className="font-semibold">Agent Name:</p>
                <p>{agent?.data?.name}</p>
              </div>
              <div>
                <p className="font-semibold">Direction:</p>
                <p>{agent?.data?.inbound_outbound}</p>
              </div>
              <div>
                <p className="font-semibold">Phone Number:</p>
                <p>{agent?.data?.phone_number}</p>
              </div>
              <div>
                <p className="font-semibold">Call Objective:</p>
                <p>{agent?.data?.call_objective}</p>
              </div>
              <div>
                <p className="font-semibold">Model:</p>
                <p>{agent?.data?.model}</p>
              </div>
              <div>
                <p className="font-semibold">Temperature:</p>
                <p>{agent?.data?.temperature}</p>
              </div>
            </div>
          </TabsContent>

          <TabsContent value="prompt">
            <div className="mt-4 whitespace-pre-wrap">{agent?.data?.prompt}</div>
          </TabsContent>

          <TabsContent value="summaryPrompt">
            <div className="mt-4 whitespace-pre-wrap">{agent?.data?.summary_prompt}</div>
          </TabsContent>

          <TabsContent value="analysisPrompt">
            <div className="mt-4 whitespace-pre-wrap">{agent?.data?.analysis_prompt}</div>
          </TabsContent>
        </Tabs>
      </Section>
    </>
  );
};

export default Agent;
